import { useMemo } from "react";
import { useGetPresence } from "../hooks/useGetPresence";

import { Avatar } from "./Avatar";
import { StatusIndicator } from "./StatusIndicator";
import { Tooltip } from "./Tooltip";

type Props = {
  presentUserIds: Set<string>;
  isAiPresent: boolean;
  avatarSize: number;
};

export function StepPresence({
  presentUserIds,
  isAiPresent,
  avatarSize,
}: Props) {
  const { usersById } = useGetPresence();

  const presentUsers = useMemo(
    () =>
      [...presentUserIds]
        .map((id) => usersById.get(id))
        .filter((u) => u != null),
    [presentUserIds, usersById]
  );

  if (presentUsers.length === 0 && !isAiPresent) return null;

  type PresenceItem =
    | { type: "user"; user: (typeof presentUsers)[number] }
    | { type: "ai" };

  const items: PresenceItem[] = [
    ...presentUsers.map((user) => ({ type: "user" as const, user })),
    ...(isAiPresent ? [{ type: "ai" as const }] : []),
  ];

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        marginLeft: 2,
        lineHeight: 0,
      }}
    >
      {items.map((item, index) => (
        <div
          key={item.type === "user" ? item.user.id : "ai"}
          style={{
            marginLeft: -2,
            position: "relative",
            zIndex: index + 1,
          }}
        >
          {item.type === "user" ? (
            <Avatar size={avatarSize} user={item.user} isPresent bare={false} />
          ) : (
            <Tooltip content="3B">
              <StatusIndicator
                state="building"
                focused
                size={avatarSize}
                opaqueFill
              />
            </Tooltip>
          )}
        </div>
      ))}
    </div>
  );
}
